import { type FunctionComponent, type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { ClockIcon } from '@trello/nachos/icons/clock';

import { BoardSwitcherTile } from './BoardSwitcherTile';
import { BoardSwitcherTiles } from './BoardSwitcherTiles';
import { BoardSwitcherTilesLoadingSkeleton } from './BoardSwitcherTilesLoadingSkeleton';
import { ExpandSection } from './ExpandSection';
import { useBoardSwitcher } from './useBoardSwitcher';

import * as styles from './RecentBoards.module.less';

export const RecentBoards: FunctionComponent = () => {
  const { recentBoards, recentLoading } = useBoardSwitcher();
  let contents: ReactNode;

  if (recentLoading) {
    contents = <BoardSwitcherTilesLoadingSkeleton />;
  } else if (recentBoards.length === 0) {
    contents = (
      <div className={styles.emptyState}>
        <FormattedMessage
          id="templates.board_switcher.no-recent-boards"
          defaultMessage="No recent boards."
          description="Text shown when there are no recent boards"
        />
      </div>
    );
  } else {
    contents = (
      <BoardSwitcherTiles>
        {recentBoards.map(({ id }) => (
          <BoardSwitcherTile key={id} boardId={id} section="recent" />
        ))}
      </BoardSwitcherTiles>
    );
  }

  return (
    <ExpandSection
      id="recent"
      title={
        <span>
          <ClockIcon size="small" />
          <FormattedMessage
            id="templates.board_switcher.recent"
            defaultMessage="Recent"
            description="Title of recent workspaces section on the board switcher"
          />
        </span>
      }
      isExpandedByDefault
      testId="board-switcher-recent-boards"
    >
      {contents}
    </ExpandSection>
  );
};
